// removed by extract-text-webpack-plugin
module.exports = {"Order":"Order__Order__W-Npf","Skills":"Order__Skills__22Bq1","Skill":"Order__Skill__1je38"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Order/Order.css
// module id = 190
// module chunks = 0